import { html, View, type Html, rune } from 'rune-ts';
import klass from './ScaleSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { blueHeartIcon } from '../../icons';
import gsap from 'gsap';
import { ScrollState, SetScrollIndexEvent } from '../../HandmadeCreatorLandingPage';
import { ONE_SCROLL_INDEX_MAP_PC } from '../../const';

interface ScaleSectionData {
  scroll_state: ScrollState;
}

export class ScaleSection extends View<ScaleSectionData> {
  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      scale_title: html.preventEscape(ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}scale_title`)),
      scale_description: html.preventEscape(ET(`mps2::landing::handmade::scale_description`)),
    };

    return html`
      <section class="${klass.container}">
        <div class="${klass.scale_title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
          ${texts.scale_title}
        </div>
        <div class="${klass.scale_desc} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
          ${texts.scale_description}
        </div>
        <div class="${klass.heart_icon}">${blueHeartIcon}</div>
      </section>
    `;
  }

  override onRender() {
    this.setInitialStatus();
    this.initScaleScrollTrigger();
  }

  setInitialStatus() {
    gsap.set(`.${klass.scale_desc}`, { opacity: 0 });
    gsap.set(`.${klass.heart_icon}`, { opacity: 0, scale: 0.1 });
  }

  initScaleScrollTrigger() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    if (!is_mobile) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: `.${klass.container}`,
          start: 'top top',
          end: 'bottom top',
          pin: true,
          pinSpacing: true,
          scrub: true,
          onEnter: () => {
            this.dispatchEvent(SetScrollIndexEvent, {
              bubbles: true,
              detail: { current_index: ONE_SCROLL_INDEX_MAP_PC.scale_index },
            });
          },
          onEnterBack: () => {
            this.dispatchEvent(SetScrollIndexEvent, {
              bubbles: true,
              detail: { current_index: ONE_SCROLL_INDEX_MAP_PC.scale_index + 1 },
            });
          },
        },
      });

      tl.to(`.${klass.heart_icon}`, { scale: 1, opacity: 1 })
        .to(`.${klass.scale_title}`, { opacity: 0 }, '<')
        .to(`.${klass.scale_desc}`, { opacity: 1 }, '<');
    }
  }
}
